import React, { useState, useEffect } from 'react';
import {
  EditableLabelContainer,
  Label,
  EditPopup,
  Input,
  IconButton,
  VerticalSeparator,
  ButtonsContainer,
} from './EditableLabel.styles';
import { Icon } from 'components/atoms';
import { EditableLabelProps } from './types';
import PercentageInput from 'components/atoms/percentage-input';

const EditableLabel: React.FC<EditableLabelProps> = ({
  value,
  onSave,
  canEdit = true,
  placeholder,
  inputType = null,
  light = false,
}) => {
  const [isEditable, setIsEditable] = useState(false);
  const [editValue, setEditValue] = useState(value);

  useEffect(() => {
    if (isEditable) {
      setEditValue(value);
    }
  }, [isEditable, value]);

  const handleSave = () => {
    onSave(editValue);
    setIsEditable(false);
  };

  const handleCancel = () => {
    setIsEditable(false);
    setEditValue(value);
  };

  return (
    <EditableLabelContainer>
      {isEditable ? (
        <EditPopup>
          {inputType === 'percentage' ? (
            <PercentageInput
              value={editValue}
              onValueChange={(newValue) => setEditValue(newValue)}
              placeholder={placeholder}
              input={Input}
            />
          ) : (
            <Input
              type="text"
              onChange={(e) => setEditValue(e.target.value)}
              value={editValue}
              placeholder={placeholder}
            />
          )}
          <ButtonsContainer>
            <IconButton onClick={handleSave}>
              <Icon icon="check" aria-hidden size="xxxs" colour="#58A733" />
            </IconButton>
            <VerticalSeparator />
            <IconButton onClick={handleCancel}>
              <Icon icon="close" aria-hidden size="xxxs" colour="#DB0D00" />
            </IconButton>
          </ButtonsContainer>
        </EditPopup>
      ) : (
        <>
          <Label light={light} isPlaceholder={!value}>
            {value || placeholder}
          </Label>
          {canEdit && (
            <IconButton onClick={() => setIsEditable(true)}>
              <Icon icon="edit-pencil" aria-hidden size="xxxs" colour="#22C3BB" />
            </IconButton>
          )}
        </>
      )}
    </EditableLabelContainer>
  );
};

export default EditableLabel;
